import type { SuperbarTheme } from './theme';

export const superbarLightTheme: SuperbarTheme = {
  mode: 'light',
  colors: {
    surface: {
      appBg: '#ffffff',
      appBgMinimized: '#ffffff',
      systemMessageBg: '#ffffff',
      notificationBg: '#ffffff',
    },
    ink: {
      primary: '#000000',
      secondary: '#3A3A3A',
      tertiary: '#666666',
      inverse: '#ffffff',
      muted: 'rgba(0,0,0,0.5)',
      disabled: '#CCCCCC',
    },
    border: {
      shell: '#D5D5D5',
      systemMessageBottom: '#D5D5D5',
    },
    selection: {
      bg: '#000000',
      fg: '#FFFFFF',
    },
  },
  shadows: {
    shell: '0px 0px 10px rgba(0,0,0,0.15), 4px 4px 60px rgba(0,0,0,0.25)',
    minimizedShell: '0 0 20px rgba(0,0,0,0.2)',
    systemMessageCloseButton: '0 0 10px rgba(0,0,0,0.08)',
    notification: '0px 4px 16px rgba(0, 0, 0, 0.12)',
  },
  radii: {
    panel: '28px',
    minimizedPanelTop: '28px',
    minimizedPanel: '20px',
    pillButton: '25px',
    round: '100%',
  },
  components: {
    chatShell: {
      borderColor: '#D5D5D5',
      shadow: '0px 0px 10px rgba(0,0,0,0.15), 4px 4px 60px rgba(0,0,0,0.25)',
      background: 'transparent',
    },
    chatShellClosed: {
      background: 'rgba(255, 255, 255, 0.5)',
      shadow: '0 0 20px rgba(0,0,0,0.2)',
      radius: '20px',
    },
    systemMessage: {
      background: '#ffffff',
      borderBottomColor: '#E6E6E6',
      radiusTop: '28px',
    },
    menu: {
      iconColor: 'rgba(0,0, 0, 0.3)',
      textColor: '#000000',
      itemHoverBackground: 'rgba(0, 0, 0, 0.05)', // gray-100 equivalent
      poweredBy: {
        iconBgColor: 'rgba(0, 0, 0, 1)',
        iconColor: '#FFFFFF',
        dividerColor: '#E6E6E6',
      },
      closeButton: {
        background: '#ffffff',
        borderColor: 'rgba(0,0,0,0.1)',
        icon: '#999999',
        iconHover: '#666666',
        backgroundHover: '#000',
      },
    },
    aiFilters: {
      titleColor: '#000000',
      nextQuestionButton: {
        background: '#F5F5F5',
        borderColor: 'rgba(213, 213, 213, 0.5)',
        textColor: 'rgba(112, 112, 114, 1)',
        hoverBackground: '#E5E5E5',
      },
      filter: {
        background: '#FFFFFF',
        textColor: '#000000',
        borderColor: 'rgba(213, 213, 213, 0.5)',
        hoverBackground: '#F9FAFB',
        clearIconColor: '#999999',
        clearIconHoverColor: '#666666',
      },
    },
    loader: {
      color: '0, 0, 0',
      opacity: '0.4',
      stableOpacity: '',
    },
    inputForm: {
      background: 'rgba(255, 255, 255, 0.4)',
      radiusTopWhenNoSystemMessage: '42px',
      radiusBottom: '43px',
      backdropFilter: 'saturate(1.8) blur(20px)',
      boxShadow:
        '0 0 10px 0 rgba(0, 0, 0, 0.15), 4px 4px 60px 0 rgba(0, 0, 0, 0.25)',
    },
    inputText: {
      text: '#000000',
      textLoading: '#000000',
      selectionBg: '#000000',
      selectionText: '#FFFFFF',
      textShadow: '0px 1px 0px rgb(0 0 0 / 0.05)',
    },
    placeholder: {
      text: 'rgba(0,0,0,0.5)',
      className: 'placeholder:caddietw-text-black',
    },
    assistantMessage: {
      text: '#000000',
      ctaButton: {
        background: '#000000',
        text: '#FFFFFF',
        hoverBackground: 'rgba(0,0,0,0.8)',
      },
      closeButton: {
        background: '#ffffff',
        borderColor: 'rgba(0,0,0,0.1)',
        icon: '#666666',
        iconHover: '#666666',
        backgroundHover: '#ffffff',
      },
    },
    notification: {
      root: {
        background: '#ffffff',
        border: 'none',
        radius: '10px',
        padding: '14px 12px',
        shadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
      },
      title: {
        color: '#000000',
        fontWeight: '400',
      },
      description: {
        color: '#666666',
      },
      closeButton: {
        color: '#666666',
        hoverBg: 'rgba(0, 0, 0, 0.05)',
        hoverColor: '#666666',
      },
    },
  },
};
